/**
 * Ce qu'on avait commence a ecrire dans une conversation.
 *
 * Le texte en cours vivait dans l'ecran du fil : en sortir le demontait,
 * et la phrase commencee partait avec. Il est garde ici, par compte et par
 * conversation, jusqu'a ce qu'il parte ou qu'on l'efface.
 *
 * Le stockage du telephone plutot que la base : un brouillon n'est a
 * personne d'autre, et il survit ainsi au rechargement de l'interface
 * comme a la fermeture de l'application.
 */
const PREFIXE = 'sirocco.brouillon.';

function cle(uid: string, conversationId: string): string {
  return `${PREFIXE}${uid}.${conversationId}`;
}

export function lireLeBrouillon(uid: string, conversationId: string): string {
  try {
    return localStorage.getItem(cle(uid, conversationId)) ?? '';
  } catch {
    return '';
  }
}

/** Un brouillon vide s'efface : il n'y a plus rien a retrouver. */
export function garderLeBrouillon(uid: string, conversationId: string, texte: string): void {
  try {
    if (texte.trim()) localStorage.setItem(cle(uid, conversationId), texte);
    else localStorage.removeItem(cle(uid, conversationId));
  } catch {
    // Stockage refuse : le brouillon vit le temps de l'ecran, comme avant.
  }
}
